import { DismissFilledIcon, LocationPinFilledIcon } from '@iheartjane/reefer';
import { useEffect, useRef } from 'react';

import { useStoreSwitcher } from '@jane/bloom/hooks/storeSwitcher/useStoreSwitcher';
import { useCustomLanguage } from '@jane/bloom/hooks/useCustomLanguage';

import styles from './addressField.module.css';

export type AddressFieldProps = {
  displayAddress: string;
  onAddressTextChange: (address: string) => void;
};

export function AddressField({
  displayAddress,
  onAddressTextChange,
}: AddressFieldProps) {
  const { busy, isUndeliverableAddress, isVisible, searchReservationMode } =
    useStoreSwitcher();
  const customLanguage = useCustomLanguage();
  const reservationModeLabel =
    customLanguage.reservationModeLabels[searchReservationMode] ||
    searchReservationMode;

  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (inputRef.current && isUndeliverableAddress && isVisible) {
      inputRef.current.focus();
    }
  }, [isUndeliverableAddress, isVisible]);

  return (
    <div className={styles['field']}>
      <div className={styles['startIcon']}>
        <LocationPinFilledIcon size="sm" />
      </div>
      <input
        disabled={busy}
        type="text"
        name="storeSwitcherSearch"
        className={styles['input']}
        placeholder={`Enter your address for ${reservationModeLabel}`}
        onChange={(event) => {
          onAddressTextChange(event.target.value);
        }}
        value={displayAddress}
        ref={inputRef}
      />
      {displayAddress !== '' && (
        <div className={styles['clearIcon']}>
          <DismissFilledIcon
            altText="clear address"
            onClick={() => onAddressTextChange('')}
          />
        </div>
      )}
    </div>
  );
}
